module.exports = "pegasus/assets/blocks/column-8-theme4.png";